import { makeAutoObservable } from "mobx"
import schemes from "./schemes"

class AppStore {

  drawerOpen = false
  currentScheme: keyof typeof schemes = Object.keys(schemes)[0] as any

  constructor() {
    makeAutoObservable(this)
  }

  setDrawerOpen(drawerOpen: boolean) {
    this.drawerOpen = drawerOpen
  }

  setScheme(key: typeof this.currentScheme) {
    this.currentScheme = key
  }

}

const appStore = new AppStore()
export default appStore